//@flow
import React from 'react'
import regionsMap from './images/popular.svg'
import './styles.scss'


export class Popular extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }
  
  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {

    return <div className='popular'>
      <h3>Les chiens de petite taille sont les plus nombreux</h3>
      <img src={regionsMap} alt='chart' />
      <div className="labels">
        <div className='one'>grand</div>
        <div className='two'>petit</div>
        <div className='three'>moyen</div>
        <div className='four'>très{this.state.isMobile&&(<br />)} grand</div>
      </div>
      <div className="hint">
        <div className='split'>
          <div className='left'>
            <div><b>petit:</b></div><div>moins de 45 cm {this.state.isMobile&&(<br />)} et moins de 15 kg</div>
            <div><b>moyen:</b></div><div>45–55 cm,{this.state.isMobile&&(<br />)} 15–25 kg</div>
          </div>

          <div className='right'>
            <div><b>grand:</b></div><div>55–70 cm,{this.state.isMobile&&(<br />)} 25–45 kg</div>
            <div><b>très grand:</b></div><div>plus de 70 cm{this.state.isMobile&&(<br />)} et plus de 45 kg</div>
          </div>
        </div>
      </div>
      <div className="source">Source: <a href='https://tierstatistik.identitas.ch/fr/dogs-sizecategory.html'>Identitas</a></div>
    </div>
  }
}



             